import { formatAddress, formatCurrencyNoDecimals } from '@if/core/utils'
import { ActionList, BodyText, type Action } from '@if/mui'
import { ListItem, ListItemText, Tooltip } from '@mui/material'
import { ApplicantJob } from '@src/types/CreditApplicationSchema'
import { Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  onDelete?: () => void
  onEdit?: () => void
  data: ApplicantJob
  disableEdit: boolean
  toolTip: string
}

const DisplayJobInfosListItem = ({ onDelete, onEdit, data, disableEdit, toolTip }: Props) => {
  const { address } = data
  const { t } = useTranslation()

  const actions: Action[] = [
    ...(onEdit ? [{ icon: Pencil, label: t('common.edit'), onClick: onEdit, disabled: disableEdit }] : []),
    ...(onDelete
      ? [
          {
            icon: Trash2,
            label: t('common.delete'),
            tone: 'destructive' as const,
            onClick: onDelete,
            disabled: disableEdit,
          },
        ]
      : []),
  ]

  return (
    <ListItem sx={{ pr: 10 }} disableGutters secondaryAction={<ActionList actions={actions} />}>
      <Tooltip title={toolTip}>
        <ListItemText
          primary={
            <BodyText>{`${data.employerName} (${t(`EJobType.${data.jobType}`, { ns: 'enum' })}) : ${
              data.jobTitle
            } ${formatCurrencyNoDecimals(data.annualSalary)}`}</BodyText>
          }
          secondary={formatAddress(address)}
        />
      </Tooltip>
    </ListItem>
  )
}

export default DisplayJobInfosListItem
